'use client';
import './Ads.css';
import Image from 'next/image';
import { useRef } from 'react';
import { trackAdClick } from './utils/trackAdClick';

function resolveImageSizes({ className = '', containerClass = '', width }) {
    const tokens = `${className} ${containerClass}`;

    if (/bottom_ad_image/.test(tokens)) {
        return '(max-width: 450px) 100vw, (max-width: 1200px) 95vw, 1200px';
    }

    if (/side_ad_image|global_side_ad_image|jobs_side_ad_image|business_side_ad_image/.test(tokens)) {
        return '(max-width: 1023px) 100vw, 320px';
    }

    if (Number(width) > 0) {
        return `${Number(width)}px`;
    }

    return '100vw';
}

const AdBanner = ({
    slotKey,
    adId,
    href,
    imageSrc,
    alt = 'Advertisement',
    width,
    height,
    className = '',
    containerClass = '',
    id = '',
    useNextImage = false,
    openInNewTab = true,
}) => {
    const adRef = useRef(null);
    const sizes = resolveImageSizes({ className, containerClass, width });

    const handleClick = () => {
        trackAdClick({
            slotKey,
            adId,
            href,
            imageSrc,
            placement: id || containerClass || undefined,
        });
    };

    return (
        <div ref={adRef} className={containerClass} id={id}>
            <a
                href={href}
                onClick={handleClick}
                target={openInNewTab ? '_blank' : '_self'}
                rel={openInNewTab ? 'noopener noreferrer sponsored' : undefined}
            >
                {useNextImage ? (
                    <Image
                        src={imageSrc}
                        alt={alt}
                        width={width}
                        height={height}
                        quality={65}
                        sizes={sizes}
                        className={className}
                    />
                ) : (
                    <img
                        src={imageSrc}
                        alt={alt}
                        className={className}
                        width={width || 1200}
                        height={height || 630}
                        loading="lazy"
                        decoding="async"
                    />
                )}
            </a>
        </div>
    );
};

export default AdBanner;
